export default __webpack_public_path__ + "static/media/czech-republic-svgrepo-com.57c7199f.svg";